<template>
  <multiple-cascader
    v-model="selection"
    :max="multiple ? 100 : 1"
    :min="1"
    add-text="Ajouter une mesure"
    :title="i => 'Mesure ' + i"
    :options="measures"
    :get-hierarchy="v => ['group#' + api.measure.groupName(v), api.measure.uniqueName(v)]"
    :props="props" />
</template>

<script>
import MultipleCascader from './MultipleCascader.vue'
import customGraphApiAware from './mixins/customGraphApiAware'
import api from './api'

export default {
  components: {
    MultipleCascader: MultipleCascader
  },
  props: {
    value: {
      default: null
    },
    multiple: {
      type: Boolean,
      default: false
    },
    measureList: {
      type: Array,
      required: true
    }
  },
  mixins: [
    customGraphApiAware
  ],
  data () {
    return {
      props: {
        label: api.measure.props.name,
        value: api.measure.props.uniqueName,
        children: 'children',
        disabled: 'disabled'
      },
      selection: []
    }
  },
  computed: {
    measures () {
      const measures = []
      this.measureList.forEach(measure => {
        let group = measures.find(m => {
          return 'group#' + this.api.measure.groupName(measure) === this.api.measure.uniqueName(m)
        })
        if (typeof group === 'undefined') {
          group = { children: [] }
          group[this.api.measure.props.uniqueName] = 'group#' + this.api.measure.groupName(measure)
          group[this.api.measure.props.name] = this.api.measure.groupName(measure)
          measures.push(group)
        }
        group.children.push(measure)
      })
      return measures
    }
  },
  watch: {
    value () {
      // this.updateSelection()
    },
    selection () {
      if (this.selection.length) {
        this.$emit(
          'input',
          this.multiple ? this.selection.map(s => s.value) : [this.selection[0].value]
        )
      } else {
        this.$emit('input', [])
      }
    }
  },
  mounted () {
    if (!Array.isArray(this.value) || this.value.length) {
      this.updateSelection()
    }
  },
  methods: {
    updateSelection () {
      if (Array.isArray(this.value)) {
        this.selection.splice(0, this.selection.length, ...this.value.map(v => {
          return {
            value: v,
            options: {}
          }
        }))
      } else if(this.value === null) {
        this.selection.splice(0)
      } else {
        this.selection.splice(0, this.selection.length, {
          value: this.value,
          options: {}
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// node_modules/macarons-graphs-front/src/MeasureHierarchy.vue